var basex = require('base-x')
var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'

module.exports = basex(ALPHABET)



//////////////////
// WEBPACK FOOTER
// ./node_modules/dcorejs-lib/node_modules/bs58/index.js
// module id = 43
// module chunks = 0